import { ReactNode } from 'react';
import { CarrierWebviewHeader } from '../../CarrierWebviewHeader';

interface SuperPayWebviewHeaderProps {
  children: ReactNode;
}

export function SuperPayWebviewHeader({
  children,
}: SuperPayWebviewHeaderProps) {
  return <CarrierWebviewHeader>{children}</CarrierWebviewHeader>;
}
